export enum CigTourParts {
    TOBACCO = "tobacco",
    SMOKE = "smoke",
    FILTER = "filter",
    CHEMICAL = "chemical",
}
